import React, { FC, useEffect, useState } from "react";
import { Button, Col, Container, Row } from "reactstrap";
import { Utilities, Enums } from "@utils";
import { IFEStep4Dto } from "@models/*";
import { FormProaFEPresenter } from "@presenters/screens/form-proa-fe.presenter";
import { AEABatchGrid, AEAField } from "@components/";
import { Toast } from "devextreme-react/toast";
import ErrorTable from '@/components/ui/aea-error-table/aea-error-table';
import styles from "../../form-proa-subproject-fe.module.scss";

export interface IExpectedResult {
    tabIndex: number;
    subventionCodeId: number;
    objIndex: number;
    resIndex: number;   
    dataColumns: any;
    stepData: IFEStep4Dto[];
    startDate: any;
    endDate: any;
    alertEndDate: boolean;
    readOnly: any;
    showAlerts: boolean;
    handleSwitch?(): void;
    setStepData(data: any): void;
}

const ExpectedResult: FC<IExpectedResult> = (props) => {

    const [expectedResultsGridData, setExpectedResultsGridData] = useState(null);
    const [activitiesGridData, setActivitiesGridData] = useState(null);
    const [totalExpertResult, setTotalExpertResult] = useState(0);
    const [modalExcel, setModalExcel] = useState<boolean>(false);
    const [gridDataExcel, setGridDataExcel] = useState(null);

    const [resData, setResData] = useState(null);
    const [actData, setActData] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [AlertsAct, setAlertsAct] = useState(false);
    const [AlertsRes, setAlertsRes] = useState(false);

    const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});

    const onHidingToast = () => {
        setToastConfig({
        ...toastConfig,
        isVisible: false,
      });
    };

    const handleLoad = (section: string) => {
        if(section === "Act"){
            setAlertsAct(true)
            setActivitiesGridData(null)
        }else{
            setAlertsRes(true)
            setExpectedResultsGridData(null)
        }
        
        props.handleSwitch()
        setRefresh(refresh => !refresh)
    }

    const presenter = new FormProaFEPresenter({
        state: {
            index: props.objIndex,
            step4Data: props.stepData,
            dataColumns: props.dataColumns,
            subventionCodeId: props.subventionCodeId,
            indexTab: props.resIndex,
            expectedResultsGridData: expectedResultsGridData,
            readOnly: props.readOnly,
            modalExcel,
            totalExpertResult: totalExpertResult,
            activitiesGridData: activitiesGridData,
            setExpectedResultsGridData: setExpectedResultsGridData,
            setActivitiesGridData: setActivitiesGridData,
            setTotalExpertResult: setTotalExpertResult,
            setStep4Data: props.setStepData,
            setModalExcel,
            setGridDataExcel
        },
        startDate: props.startDate,
        endDate: props.endDate,
        setPartialSave: props.setStepData,
        handleLoad: handleLoad
    });

    useEffect(() => {        
        setExpectedResultsGridData(null);
        setActivitiesGridData(null);
        setRefresh(refresh => !refresh)
    }, [props.startDate, props.endDate])

    useEffect(() => {
        presenter.expectedResultGridData(props.tabIndex, props.objIndex, props.resIndex);
        presenter.activitiesGridData(props.tabIndex, props.objIndex, props.resIndex);
    }, [props.stepData?.[props.objIndex]?.results?.[props.resIndex], refresh])

    const handleChangeAct = (option: any) => {
        let field = option?.column?.dataField  
        let message = (!field?.includes(Enums.ProaBasicFields.MetaValor)) ? presenter.handleChangeValue(option, true) : null
        if(!message) message = presenter.handleChangeValueAct(option)

        if(!!message){
          setToastConfig({
            isVisible: true,
            type: 'info',
            message
          })
        }
    }

    const handleChangeRes = (option: any) => {
        let message = presenter.handleChangeValue(option)
        if(!message) message = presenter.handleChangeValueObjRes(option)

        if(!!message){
          setToastConfig({
            isVisible: true,
            type: 'info',
            message
          })
        }
    }

    useEffect(() => {
        if (!Utilities.isNullEmptyObject(activitiesGridData)) getActData()
    }, [props.stepData?.[props.objIndex]?.results?.[props.resIndex], activitiesGridData, modalExcel, gridDataExcel])

    useEffect(() => {
        if (!Utilities.isNullEmptyObject(expectedResultsGridData)) getResData()
    }, [props.stepData?.[props.objIndex]?.results?.[props.resIndex], expectedResultsGridData, modalExcel, gridDataExcel])

    const getActData = () => {
        setActData(
            <Row>
                <Col><AEABatchGrid {...activitiesGridData} addModifiedAttr={true} handleChange={handleChangeAct} checkContent currentData={!!props.stepData?.[props.objIndex]?.results?.[props.resIndex]} modalExcel={(gridDataExcel == 'Actividades') ? modalExcel : false} gridDataExcel={activitiesGridData} presenter={presenter} onCellPreRender={presenter.onCellPreRender}></AEABatchGrid></Col>
            </Row>
        )
    }

    const getResData = () => {
        setResData(
            <Row>
                <Col><AEABatchGrid {...expectedResultsGridData} handleChange={handleChangeRes}  checkContent currentData={!!props.stepData?.[props.objIndex]?.results?.[props.resIndex]} modalExcel={(gridDataExcel == 'ResultadosEsperados') ? modalExcel : false} gridDataExcel={expectedResultsGridData} presenter={presenter} onCellPreRender={presenter.onCellPreRender}></AEABatchGrid></Col>
            </Row>
        )
    }

    const render = () => {
    if(!Utilities.isNullEmptyObject(props.stepData)){ 
            return (
                <Container fluid={true} style={{position: 'relative'}}>
                    <Row>
                        <Col>
                            <AEAField {...presenter.expectedResult}></AEAField>
                            <div className={styles.containerButtons}>
                            {!props.readOnly ? (
                            <Button onClick={() => {
                                setTimeout(() => {
                                    presenter.saveGenericInfoREStep4(props.tabIndex, props.objIndex, props.resIndex)
                                },500)}
                                }>
                                Guardar resultado esperado
                            </Button>
                            ) : null}
                            </div>
                        </Col>
                    </Row>
                    {((!props.stepData?.[props.objIndex]?.results?.[props.resIndex]?.details?.length) && (props.showAlerts || AlertsRes)) &&
                        <div style={{width:"100%", textAlign:"center"}}>
                            <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.currentLabels.get("AlertReqERIndicator")}</h6>
                        </div>
                    }
                    {(expectedResultsGridData?.gridProps?.id && !!resData && !!props.stepData?.[props.objIndex]?.results?.[props.resIndex]) && 
                        <ErrorTable 
                            gridId={expectedResultsGridData?.gridProps?.id} 
                            showAlerts={AlertsRes || props.showAlerts} 
                            checkFunction={presenter.checkRequiredFields} 
                        />
                    }
                    {(expectedResultsGridData?.gridProps?.id && !!resData && !!props.stepData?.[props.objIndex]?.results?.[props.resIndex] && !props.alertEndDate && !AlertsRes && !props.showAlerts) && 
                        <ErrorTable 
                            paintColumn
                            gridId={expectedResultsGridData?.gridProps?.id} 
                            showAlerts={!props.alertEndDate}
                            checkFunction={presenter.checkEndDate}
                        />
                    }
                    {!!resData ? resData : <></>}
                    <br />
                   {/*  {((!props.stepData?.[props.objIndex]?.results?.[props.resIndex]?.activities?.length) && (props.showAlerts || AlertsAct)) &&
                        <div style={{width:"100%", textAlign:"center"}}>
                            <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.currentLabels.get("AlertReqERActivity")}</h6>
                        </div>
                    } */}
                    {!!actData && actData}
                    <Toast
                        visible={toastConfig.isVisible}
                        message={toastConfig.message}
                        type={toastConfig.type}
                        onHiding={onHidingToast}
                        displayTime={10000}
                    />
                </Container>
            );
        }
    }
    return render();
}

export default ExpectedResult;